// Actions
export const AUTH__JWT_FETCH = 'AUTH__JWT_FETCH';
export const AUTH__JWT_RECEIVED = 'AUTH__JWT_RECEIVED';

// Getters
export const AUTH__JWT = 'AUTH__JWT';

// Mutations
export const AUTH__JWT_IS_LOADING = 'AUTH__JWT_IS_LOADING';
export const AUTH__JWT_MUTATE = 'AUTH__JWT_MUTATE';
